const digest = '1ecfbe04b397e16a6416bfb0802c5e8ebad9a68170e46fd5be64ba532dcf5ecd';
const css = `._tncFooter_ee0fd_1{color:#53565a;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;line-height:16px;margin:0;padding:1.5em;width:100%}._linkDecoration_ee0fd_11{text-decoration:underline!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'tncFooter': '_tncFooter_ee0fd_1', 'linkDecoration': '_linkDecoration_ee0fd_11' };
export const tncFooter = '_tncFooter_ee0fd_1';
export const linkDecoration = '_linkDecoration_ee0fd_11';
export { css, digest };